import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IWorkOrderFields {
		id?: any;
		areaId?: any;
		workOrderNo?: any;
		contractManagerId?: any;
		dateIssued?: any;
		functionalLocation?: any;
		functionalLocationDescription?: any;
		contactPersonId?: any;
		contactNo?: any;
		priorityId?: any;
		dateScopedOut?: any;
		dateScopedIn?: any;
		dateScopeEstimator?: any;
		datestamp?: any;
		changedBy?: any;
		status?: any;
		jobNumberId?: any;
		siteId?: any;
		siteSysProClientId?: any;
}

export class WorkOrderFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public areaId: IEntityModelField = { name: "areaId", displayName: "Area Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public workOrderNo: IEntityModelField = { name: "workOrderNo", displayName: "Work Order No", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public contractManagerId: IEntityModelField = { name: "contractManagerId", displayName: "Contract Manager Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public dateIssued: IEntityModelField = { name: "dateIssued", displayName: "Date Issued", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public functionalLocation: IEntityModelField = { name: "functionalLocation", displayName: "Functional Location", fieldType: FieldType.String, pattern: "NameGeneric" };
	public functionalLocationDescription: IEntityModelField = { name: "functionalLocationDescription", displayName: "Functional Location Description", fieldType: FieldType.String, pattern: "NameGeneric" };
	public contactPersonId: IEntityModelField = { name: "contactPersonId", displayName: "Contact Person Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public contactNo: IEntityModelField = { name: "contactNo", displayName: "Contact No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public priorityId: IEntityModelField = { name: "priorityId", displayName: "Priority Id", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public dateScopedOut: IEntityModelField = { name: "dateScopedOut", displayName: "Date Scoped Out", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateScopedIn: IEntityModelField = { name: "dateScopedIn", displayName: "Date Scoped In", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateScopeEstimator: IEntityModelField = { name: "dateScopeEstimator", displayName: "Date Scope Estimator", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric" };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public jobNumberId: IEntityModelField = { name: "jobNumberId", displayName: "Job Number Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public siteId: IEntityModelField = { name: "siteId", displayName: "Site Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public siteSysProClientId: IEntityModelField = { name: "siteSysProClientId", displayName: "Site Sys Pro Client Id", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.areaId);
		this.push(this.workOrderNo);
		this.push(this.contractManagerId);
		this.push(this.dateIssued);
		this.push(this.functionalLocation);
		this.push(this.functionalLocationDescription);
		this.push(this.contactPersonId);
		this.push(this.contactNo);
		this.push(this.priorityId);
		this.push(this.dateScopedOut);
		this.push(this.dateScopedIn);
		this.push(this.dateScopeEstimator);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.jobNumberId);
		this.push(this.siteId);
		this.push(this.siteSysProClientId);
	}
}

export class WorkOrderDTO implements IEntityModel {
	protected workOrderName: string = "WorkOrderModel";
	protected workOrderKeyField: string = "id";
	protected workOrderDisplayName: string = "Work Order|Work Orders";
	protected workOrderFields = new WorkOrderFields();
	public get name(): string { return this.workOrderName };
	public get keyField(): string { return this.workOrderKeyField };
	public get displayName(): string { return this.workOrderDisplayName };
	public get fields(): WorkOrderFields { return this.workOrderFields };

	constructor() {};
}
